
/*
	The ceiling on what may be uploaded. Checked in the browser so the user gets a real message
	rather than a failed request, and again by multer so the endpoint can't be abused.
 */
export const maxUploadBytes = 50000000;

/*
	Above this the upload is no longer worth keeping byte-for-byte, so 'full' becomes a webp
	re-encode of it instead. Below it the upload is stored exactly as it arrived, which is what an
	already-modest photo wants.
 */
export const reencodeFullAboveBytes = 2000000;

/* The encode quality used when a version has to be created rather than stored as uploaded. */
export const defaultImageQuality = 80;

export function describeMegabytes(bytes:number):string
{
	return `${Math.round(bytes/1000000)}MB`;
}


export interface FixedRatioImage {
	ratio:number,
	width?:number,  // One or other required
	height?:number,
//TODO probably remove this option and just use the original. NB pngs have an alpha channel that needs to be preserved.
	format?:'jpeg'|'png'|'webp'
}

export interface MaxDimensionsImage {
	maxWidth:number,
	maxHeight:number,
//TODO probably remove this option and just use the original. NB pngs have an alpha channel that needs to be preserved.
	format?:'jpeg'|'png'|'webp'
};

export type ImageSize = FixedRatioImage | MaxDimensionsImage;

export interface Image {
	ratio?:number,
	minWidth?:number,  // One or other required
	minHeight?:number,
	formats:('jpeg'|'png'|'webp')[]

	/* The format every version is stored in, whatever was uploaded. Omitted, the upload's own format
	   is kept and 'full' is stored byte-for-byte, which is what an uploaded photo wants. Set it where
	   the upload is an intermediate rather than the artefact: a losslessly captured poster arrives as
	   a PNG, and storing that PNG is both wasteful and not what should be served. */
	storeAs?:'jpeg'|'png'|'webp',

	/* Encode quality for every version this preset has to create, defaulting to
	   defaultImageQuality. Raise it where the stored image is an intermediate that gets processed
	   again later rather than something a visitor downloads. */
	quality?:number,

	large?: ImageSize,
	medium?: ImageSize,
	small?: ImageSize,
	tiny?: ImageSize
};

